// src/components/strumenti/RisoluzioneMegapixel.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

const RISOLUZIONI_NOTE = [
  { nome:"HD 720p", w:1280, h:720 },
  { nome:"Full HD 1080p", w:1920, h:1080 },
  { nome:"3 MP", w:2048, h:1536 },
  { nome:"4 MP", w:2688, h:1520 },
  { nome:"5 MP", w:2592, h:1944 },
  { nome:"4K / 8 MP", w:3840, h:2160 },
  { nome:"12 MP", w:4000, h:3000 },
];

export default function RisoluzioneMegapixel() {
  const [larghezza, setLarghezza] = useState("");
  const [altezza, setAltezza] = useState("");

  const w = leggiNumero(larghezza)||0;
  const h = leggiNumero(altezza)||0;
  const mp = (w*h)/1000000;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Larghezza (px)</label>
          <input value={larghezza} onChange={e=>setLarghezza(e.target.value)} style={inp} placeholder="Es. 2592"/>
        </div>
        <div>
          <label style={lbl}>Altezza (px)</label>
          <input value={altezza} onChange={e=>setAltezza(e.target.value)} style={inp} placeholder="Es. 1944"/>
        </div>
      </div>

      <div style={{ background:"#f5f3ff", border:"1px solid #ddd6fe", borderRadius:10, padding:"14px 16px", textAlign:"center", marginBottom:16 }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Risoluzione</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#6d28d9" }}>
          {mp>0 ? mp.toLocaleString("it-IT",{maximumFractionDigits:2}) : "—"}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>Megapixel</span>
        </div>
      </div>

      <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:8 }}>Risoluzioni comuni di riferimento</div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:6 }}>
        {RISOLUZIONI_NOTE.map(r => (
          <button key={r.nome} onClick={()=>{setLarghezza(String(r.w));setAltezza(String(r.h));}}
            style={{ textAlign:"left", padding:"7px 10px", border:"1px solid #e5e7eb", borderRadius:8, background:"#fff", cursor:"pointer", fontFamily:"'Inter',sans-serif" }}>
            <div style={{ fontSize:12, fontWeight:700, color:"#374151" }}>{r.nome}</div>
            <div style={{ fontSize:10, color:"#9ca3af" }}>{r.w}×{r.h}</div>
          </button>
        ))}
      </div>

      <button onClick={()=>{setLarghezza("");setAltezza("");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
